import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import InputField from "../../../common/CustomInputField";
import SelectField from "../../../common/SelectField";
import RadioButton from "../../../common/RadioButton";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "../../../common/styles/common.scss";
import { relationships } from "../../../constants/constants";
import { SecondaryButton } from "../../../common/Buttons";
import "../../../components/yourAssets/FT/familyTree.scss";
import { style } from "../../../common/common";
import {
  deleteFamilyMember,
  getFamilyMembersList,
  replaceRelationWithKeys,
  updateFamilyMemberOnEdit,
} from "../../../utils/FTUtilities";
import {
  addFamilyMember,
  getMarriageTypes,
  uploadProfilePicture,
} from "../../../services/yourAssets/FamilyTreeServices";
import { toast, Toaster } from "react-hot-toast";
import DeleteDataModal from "../BOA/DeleteDataModal";
import TextField from "../../../common/TextField";
import { useTranslation } from "react-i18next";
import { getKeyFromText, setFTGraphCheck } from "../../../utils/Utilities";
const EditMemberModal = (props) => {
  const { t } = useTranslation();
  const {
    open,
    handleClose,
    currentNode,
    refresh,
    enableSelection,
    defaultValue,
    userId,
  } = props;
  const containsNumber = (str) => {
    return /\d/.test(str);
  };
  const containSpecialChar = (str) => {
    return /[-!$%^&*()£_+|~=`{}\[\]:\/;<>?,.@#]/.test(str);
  };

  const modalSchema = Yup.object().shape({
    firstName: Yup.string()
      .label("First Name")
      .required(t("required"))
      .nullable()
      .max(20, t("first-name-max"))
      .min(3, t("first-name-min"))
      .test(
        "First Name",
        t("first-name-invalid"),
        (value) => !containsNumber(value)
      ),
    lastName: Yup.string()
      .label("Last Name")
      .required(t("required"))
      .nullable()
      .max(20, t("last-name-max"))
      .min(3, t("last-name-min"))
      .test(
        "Last Name",
        t("last-name-invalid"),
        (value) => !containsNumber(value)
      ),
    dateOfBirth: Yup.string()
      .label("Date of birth")
      .when("isChild", {
        is: true,
        then: Yup.string().required(t("required")),
      }),
    address: Yup.string()
      .label("Address")
      .max(50, t("address-max-50"))
      .min(3, t("address-min"))
      .nullable(),
    note: Yup.string().label("Note").nullable(),
    isChild: Yup.boolean(),
    mid: Yup.string().nullable(),
    mName: Yup.string().nullable(),
    fid: Yup.string().nullable(),
    fName: Yup.string().nullable(),
    // profilePicture: Yup.mixed().label("Profile picture").required(t("required")),
  });
  const [marriageContractTypes, setMarriageContractTypes] = useState([]);
  const [complicatedRelation, setComplicatedRelation] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [profilePicture, setProfilePicture] = useState("");
  const [profilePictureName, setProfilePictureName] = useState("");
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [rootUser, setRootUser] = useState(0);
  const [partnersList, setPartnersList] = useState([]);
  const [motherName, setMotherName] = useState("");
  const [extendedDeleteModalMessage, setExtendedDeleteModalMessage] =
    useState("");
  const [relatedDeletableNodes, setRelatedDeletableNodes] = useState([]);

  useEffect(() => {
    let initialValues = {
      firstName: currentNode ? currentNode?.firstName : "",
      lastName: currentNode ? currentNode?.lastName : "",
      relationship: currentNode ? currentNode?.relationship : "",
      dateOfBirth: currentNode ? currentNode?.dateOfBirth?.slice(0, 10) : "",
      personPassedAway: currentNode ? currentNode?.isDead : false,
      address: currentNode ? currentNode?.address : "",
      personLives: currentNode ? currentNode?.personsLive : false,
      note: currentNode ? currentNode?.note : "",
      profilePicture: "",
      marriageContract: currentNode ? currentNode?.marriageTypeId : "",
      isChild: [t("son"), t("daughter")].includes(currentNode?.relationship)
        ? true
        : false,
      mid: currentNode ? currentNode?.mid : "",
      fid: currentNode ? currentNode?.fid : "",
    };

    setProfilePictureName(currentNode?.pictureName);
    setInitialValues(initialValues);
    setComplicatedRelation(currentNode?.complicatedRelation);
    if (currentNode?.pids?.length > 0 && currentNode?.pids.includes(1)) {
      setRootUser(1);
    }
    const getMarriageTypeList = async () => {
      let result = await getMarriageTypes();
      if (result?.success) {
        setMarriageContractTypes([...result?.payLoad]);
        let obj = initialValues;
        for (let i = 0; i < result?.payLoad.length; i++) {
          const element = result?.payLoad[i];
          if (element?.marriageTypeId === initialValues?.marriageContract) {
            obj.marriageContract = element;
          }
        }
        setInitialValues(obj);
      }
    };
    getMarriageTypeList();

    let nodeList = getFamilyMembersList();
    // for (let i = 0; i < currentNode?.pids?.length; i++) {
    //   const elementI = currentNode?.pids[i];
    //   for (let i = 0; i < nodeList.length; i++) {
    //     const elementJ = nodeList[i];
    //     if (elementI === elementJ.id) {
    //       array.push(elementJ);
    //     }
    //   }
    // }
    if (
      // [
      //   t("relation-son"),
      //   t("relation-daughter"),
      //   t("relation-brother"),
      //   t("relation-sister"),
      // ]
      [
        "Son",
        "Daughter",
        "Brother",
        "Sister",
        "Sohn",
        "Tochter",
        "Bruder",
        "Schwester",
      ].includes(currentNode.relationship)
    ) {
      if (currentNode.fid == null) {
        let mother = nodeList.find((x) => x.id == currentNode.mid);
        let fathersList = nodeList.filter((x) => mother.pids.includes(x.id));
        setPartnersList(fathersList);
      } else if (currentNode.mid == null) {
        let father = nodeList.find((x) => x.id == currentNode.fid);
        let mothersList = nodeList.filter((x) => father.pids.includes(x.id));
        setPartnersList(mothersList);
      } else {
        let father = nodeList.find((x) => x.id == currentNode.fid);
        let selectedMother = nodeList.find((x) => x.id == currentNode.mid);
        setMotherName(selectedMother.firstName);
        let mothersList = nodeList.filter((x) => father.pids.includes(x.id));
        setPartnersList(mothersList);
      }
    }
  }, [currentNode]);

  const handleChange = (event, key, formik) => {
    let value;
    if (["relationship", "marriageType", "dateOfBirth"].includes(key)) {
      value = event;
    } else if (key === "profilePicture") {
      value = event.target.files[0];
    } else if (key == "mother" || key == "father") {
      value = event["firstName"];
    } else {
      value = event.target.value || "";
    }

    if (key === "firstName") {
      formik.setFieldValue("firstName", value);
    } else if (key === "lastName") {
      formik.setFieldValue("lastName", value);
    } else if (key === "relationship") {
      if (value.name === t("son") || value.name === t("daughter")) {
        formik.setFieldValue("isChild", true);
      } else formik.setFieldValue("isChild", false);
      formik.setFieldValue("relationship", value);
    } else if (key === "dateOfBirth") {
      formik.setFieldValue("dateOfBirth", value);
    } else if (key === "personPassedAway") {
      formik.setFieldValue("personPassedAway", !formik.values.personPassedAway);
    } else if (key === "address") {
      formik.setFieldValue("address", value);
    } else if (key === "personLives") {
      formik.setFieldValue("personLives", !formik.values.personLives);
    } else if (key === "profilePicture") {
      formik.setFieldValue("profilePicture", value);
    } else if (key === "marriageType") {
      formik.setFieldValue("marriageContract", value);
    } else if (key === "note") {
      formik.setFieldValue("note", value);
    } else if (key === "mother") {
      formik.setFieldValue("mid", event["id"]);
      formik.setFieldValue("mName", value);
    } else if (key === "father") {
      formik.setFieldValue("fid", event["id"]);
      formik.setFieldValue("fName", value);
    }
  };

  const handleSubmit = async (values, { setFieldError }) => {
    let {
      firstName,
      lastName,
      personPassedAway,
      address,
      dateOfBirth,
      personLives,
      photo = profilePicture,
      marriageContract,
      note,
      mid,
      fid,
    } = values;
    if (photo) {
      let formData = new FormData();
      formData.append("FamilyTreeImage", profilePicture);
      let result = await uploadProfilePicture(userId, formData);
      if (result?.success) {
        // toast.success(t(getKeyFromText(result?.message)));
        updateFamilyMemberOnEdit({
          nodeId: currentNode.id,
          firstName,
          lastName,
          pictureId: result?.payLoad?.familyTreeImageId,
          note,
          address,
          personPassedAway,
          dateOfBirth,
          complicatedRelation,
          personLives,
          marriageContract,
          mid,
          fid,
        });

        let membersList = getFamilyMembersList();
        await addFamilyMember(userId, membersList);

        refresh();
        handleClose();
      } else {
        toast.error(t(getKeyFromText(result?.message).replaceAll(".", "")));
      }
    } else {
      updateFamilyMemberOnEdit({
        nodeId: currentNode.id,
        firstName,
        lastName,
        address,
        personPassedAway,
        dateOfBirth,
        note,
        complicatedRelation,
        personLives,
        marriageContract,
        mid,
        fid,
      });
      let membersList = getFamilyMembersList();
      await addFamilyMember(userId, membersList);

      refresh();
      handleClose();
    }
    setFTGraphCheck(true);
  };
  const selectProfilePicture = (e) => {
    let file = e.target.files[0];
    setProfilePicture(file);
    setProfilePictureName(file.name);
  };

  const openDeleteMemberModal = async () => {
    let nodeList = getFamilyMembersList();
    const allRelatedNodes = findRelatedNodes(currentNode.id, nodeList);

    if (allRelatedNodes.length > 0) {
      setExtendedDeleteModalMessage(
        t("family-tree-related-node-delete-message")
      );
      setRelatedDeletableNodes(allRelatedNodes);
    } else {
      setExtendedDeleteModalMessage("");
      setRelatedDeletableNodes([]);
    }
    setDeleteDataModal(true);
    setUserName(currentNode.firstName);
  };
  const findRelatedNodes = (currentNodeId, nodes, visited = new Set()) => {
    if (visited.has(currentNodeId)) return [];
    visited.add(currentNodeId);
    const directlyRelatedNodes = nodes.filter(
      (node) =>
        ![1, 2, 3].includes(node.id) &&
        ((node.fid === currentNodeId && node.mid === null) ||
          (node.mid === currentNodeId && node.fid === null) ||
          (node.pids?.length === 1 &&
            node.pids?.[0] === currentNodeId &&
            node.fid === null &&
            node.mid === null))
    );
    const indirectlyRelatedNodes = nodes.filter((node) =>
      directlyRelatedNodes.some(
        (relatedNode) =>
          (node.fid === relatedNode.id || node.mid === relatedNode.id) &&
          ![1, 2, 3].includes(node.id)
      )
    );

    const relatedNodes = [...directlyRelatedNodes, ...indirectlyRelatedNodes];

    for (const node of relatedNodes) {
      const furtherRelatedNodes = findRelatedNodes(node.id, nodes, visited);
      relatedNodes.push(...furtherRelatedNodes);
    }
    return relatedNodes;
  };

  const handleDeleteMember = async () => {
    deleteFamilyMember(currentNode);
    relatedDeletableNodes.forEach((node) => {
      deleteFamilyMember(node);
    });
    let nodeList = getFamilyMembersList();
    await addFamilyMember(userId, nodeList);
    refresh();
    handleClose();
  };

  const handleComplicatedRelation = () => {
    setComplicatedRelation(!complicatedRelation);
  };

  return (
    <>
      <Toaster />
      <DeleteDataModal
        open={deleteDataModal}
        handleClose={() => {
          setDeleteDataModal(false);
        }}
        handleDelete={handleDeleteMember}
        newFlow={true}
        user={userName}
        extendedMessage={extendedDeleteModalMessage}
      />
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="add-member"
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Formik
          validationSchema={modalSchema}
          initialValues={initialValues}
          onSubmit={(values, { setFieldError }) => {
            handleSubmit(values, { setFieldError });
          }}
          enableReinitialize
        >
          {(formik) => {
            return (
              <Form>
                <Fade in={open}>
                  <Box sx={style}>
                    <Box
                      component="div"
                      className="header"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      padding="0px 10px"
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            height: "30px",
                            width: "30px",
                            marginRight: "10px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            padding: "0 5px",
                          }}
                        >
                          <img
                            src={`${currentNode?.profilePicture?.replace(
                              ".png",
                              ".png"
                              // "-form.png"
                            )}`}
                            alt="member"
                            width="auto"
                            height="80%"
                            style={{
                              marginTop: "2px",
                            }}
                          />
                        </div>
                        <p>
                          {t(
                            replaceRelationWithKeys(
                              currentNode?.relationship
                            ).toLowerCase()
                          )}
                        </p>
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {![1, 2, 3].includes(currentNode.id) && (
                          <DeleteOutlineIcon
                            onClick={openDeleteMemberModal}
                            sx={{ cursor: "pointer" }}
                          />
                        )}
                        <CloseIcon
                          onClick={handleClose}
                          sx={{ cursor: "pointer" }}
                        />
                      </div>
                    </Box>
                    <Box padding="0px 10px" sx={{ marginBottom: "20px" }}>
                      {/* <InputField
                        label="First Name"
                        value={formik.values.firstName}
                        onChange={(e) => {
                          handleChange(e, "firstName", formik);
                        }}
                        name="firstName"
                        error={formik.errors}
                      /> */}
                      <TextField
                        label={t("input-1")}
                        value={formik.values.firstName}
                        onChange={(e) => {
                          handleChange(e, "firstName", formik);
                        }}
                        name="firstName"
                        error={
                          formik.errors.firstName && formik.touched.firstName
                            ? formik.errors.firstName
                            : ""
                        }
                      />
                      {currentNode?.relationship !== "Pet" && (
                        // <InputField
                        //   label="Last Name"
                        //   value={formik.values.lastName}
                        //   onChange={(e) => {
                        //     handleChange(e, "lastName", formik);
                        //   }}
                        //   name="lastName"
                        //   error={formik.errors}
                        // />
                        <TextField
                          label={t("input-10")}
                          value={formik.values.lastName}
                          onChange={(e) => {
                            handleChange(e, "lastName", formik);
                          }}
                          name="lastName"
                          error={
                            formik.errors.lastName && formik.touched.lastName
                              ? formik.errors.lastName
                              : ""
                          }
                        />
                      )}
                      {currentNode?.id !== 1 &&
                        currentNode?.relationship !== "Friend" &&
                        currentNode?.relationship !== "Pet" && (
                          <>
                            <SelectField
                              label={t("input-15")}
                              defaultValue={defaultValue}
                              value={formik.values?.relationship || ""}
                              onChange={(item) => {
                                handleChange(item, "relationship", formik);
                              }}
                              menuList={relationships}
                              enableSelection={enableSelection}
                              error={formik.errors}
                            />
                          </>
                        )}
                      {
                        // [
                        //   t("relation-son"),
                        //   t("relation-daughter"),
                        //   t("relation-brother"),
                        //   t("relation-sister"),
                        // ]
                        [
                          "Son",
                          "Daughter",
                          "Brother",
                          "Sister",
                          "Sohn",
                          "Tochter",
                          "Bruder",
                          "Schwester",
                        ].includes(defaultValue?.name) &&
                          (currentNode.mid == null ||
                            currentNode.fid != null) && (
                            <SelectField
                              label={t("relation-mothe")}
                              // value={formik.values?.parent?.firstName || ""}
                              value={
                                formik.values.mName
                                  ? formik.values.mName
                                  : motherName
                              }
                              name="mid"
                              onChange={(e) => {
                                handleChange(e, "mother", formik);
                              }}
                              menuList={partnersList}
                              error={formik.errors}
                            />
                          )
                      }
                      {
                        // [
                        //   t("relation-son"),
                        //   t("relation-daughter"),
                        //   t("relation-brother"),
                        //   t("relation-sister"),
                        // ]
                        [
                          "Son",
                          "Daughter",
                          "Brother",
                          "Sister",
                          "Sohn",
                          "Tochter",
                          "Bruder",
                          "Schwester",
                        ].includes(defaultValue?.name) &&
                          currentNode.fid == null && (
                            <SelectField
                              label={t("relation-father")}
                              // value={formik.values?.parent?.firstName || ""}
                              value={formik.values.fName}
                              name="fid"
                              onChange={(e) => {
                                handleChange(e, "father", formik);
                              }}
                              menuList={partnersList}
                              error={formik.errors}
                            />
                          )
                      }
                      {rootUser === 1 &&
                        currentNode?.relationship.includes("Partner") &&
                        !currentNode?.relationship.includes("Ex") && (
                          <SelectField
                            label={t("marriage-contract-type")}
                            value={
                              t(
                                formik.values?.marriageContract?.translationKey
                              ) || ""
                            }
                            onChange={(item) => {
                              handleChange(item, "marriageType", formik);
                            }}
                            menuList={marriageContractTypes}
                            error={formik.errors}
                          />
                        )}
                      {/* <InputField
                        name="dateOfBirth"
                        label="Date of birth"
                        value={formik.values.dateOfBirth}
                        onChange={(e) => {
                          handleChange(e, "dateOfBirth", formik);
                        }}
                        type="date"
                        error={formik.errors}
                      /> */}
                      <InputField
                        label={t("input-2")}
                        type="date"
                        value={formik.values.dateOfBirth}
                        onChange={(e) => {
                          handleChange(e, "dateOfBirth", formik);
                        }}
                        name="dateOfBirth"
                        error={
                          formik.errors.dateOfBirth &&
                          formik.touched.dateOfBirth
                            ? formik.errors.dateOfBirth
                            : ""
                        }
                      />
                      {currentNode?.relationship !== "Pet" &&
                        currentNode?.id !== 1 && (
                          <RadioButton
                            name="personPassedAway"
                            id={1}
                            label={t("passed-away-txt")}
                            value={1}
                            checked={formik.values.personPassedAway}
                            onChange={(e) => {
                              handleChange(e, "personPassedAway", formik);
                            }}
                          />
                        )}
                      {currentNode?.relationship !== "Pet" && (
                        // <InputField
                        //   name="address"
                        //   label="Address"
                        //   value={formik.values.address}
                        //   onChange={(e) => {
                        //     handleChange(e, "address", formik);
                        //   }}
                        //   error={formik.errors}
                        // />
                        <TextField
                          label={t("input-12")}
                          value={formik.values.address}
                          onChange={(e) => {
                            handleChange(e, "address", formik);
                          }}
                          name="address"
                          error={
                            formik.errors.address && formik.touched.address
                              ? formik.errors.address
                              : ""
                          }
                        />
                      )}
                      {currentNode?.relationship !== "Pet" &&
                        currentNode?.id !== 1 && (
                          <RadioButton
                            name="personLives"
                            id={2}
                            label={t("live-withYou-txt")}
                            value={2}
                            checked={formik.values.personLives}
                            onChange={(e) => {
                              handleChange(e, "personLives", formik);
                            }}
                          />
                        )}
                      <InputField
                        label={t("input-18")}
                        onChange={selectProfilePicture}
                        name="profilePicture"
                        type="file"
                        // error={formik.errors}
                        docName={profilePictureName}
                        accept="image/png, image/gif, image/jpeg"
                      />

                      {currentNode?.relationship !== "Pet" &&
                        currentNode?.relationship !== "Friend" &&
                        currentNode?.id !== 1 && (
                          <div
                            style={{
                              width: "100%",
                              backgroundColor: complicatedRelation
                                ? "#DFC8DB"
                                : "#DEDEDE",
                              borderRadius: "25px",
                              padding: "5px 0px ",
                              fontSize: "0.9rem",
                              fontWeight: "400",
                              textAlign: "center",
                              marginTop: "10px",
                              color: complicatedRelation
                                ? "#444561"
                                : "#707070",
                            }}
                          >
                            <p
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={handleComplicatedRelation}
                              dangerouslySetInnerHTML={{
                                __html: t("input-14"),
                              }}
                            ></p>
                          </div>
                        )}
                      {currentNode?.relationship === "Pet" && (
                        <InputField
                          name="note"
                          label={t("input-17")}
                          type="textarea"
                          value={formik.values.note}
                          onChange={(e) => {
                            handleChange(e, "note", formik);
                          }}
                        />
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        <SecondaryButton
                          title={t("save")}
                          bgColor="color.magentaLight2"
                          borderRadius="13px"
                          width="120px"
                          padding="8px 35px"
                          // marginLeft="20px"
                          click={formik.handleSubmit}
                          textTransform="capitalize"
                          border="1px solid #dfc8db"
                        />
                      </div>
                    </Box>
                  </Box>
                </Fade>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default EditMemberModal;
